import { v } from '@/theme/tokens';

interface SparklineProps {
  data: (number | null)[];
  color?: string;
  width?: number;
  height?: number;
}

export function Sparkline({ data, color, width = 96, height = 30 }: SparklineProps) {
  const stroke = color ?? v('accent');
  const points = data.filter((d): d is number => d !== null && Number.isFinite(d));
  if (points.length < 2) return <div style={{ width, height }} />;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const x = (i: number) => (width * i) / (data.length - 1);
  const y = (value: number) => height - 2 - (height - 4) * ((value - min) / range);

  let path = '';
  data.forEach((value, i) => {
    if (value === null || !Number.isFinite(value)) return;
    path += `${path ? 'L' : 'M'}${x(i).toFixed(1)} ${y(value).toFixed(1)} `;
  });

  const last = data[data.length - 1];

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
      <path
        d={path}
        fill="none"
        stroke={stroke}
        strokeWidth={1.8}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {last !== null && Number.isFinite(last) && (
        <circle cx={x(data.length - 1)} cy={y(last)} r={2.4} fill={stroke} />
      )}
    </svg>
  );
}
